<template>
	<div class="HeaderIdentity">
		<!-- If product is defined (clo, ebird, bow, ml, etc.) -->
		<template v-if="product">
			<!-- Product: Cornell Lab (clo) -->
			<template v-if="product === 'clo'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForMedium" style="--logoHeight: 2rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_primary_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForMedium" style="--logoHeight: 2rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_primary_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: Birds of the World (bow) -->
			<template v-if="product === 'bow'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForHeaderBreakpoint" style="--logoHeight: 1.75rem; --logoPadding: 1.25rem">
					<img :src="`${logoBaseUrl}clo_birdsoftheworld_short_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForHeaderBreakpoint" style="--logoHeight: 2.25rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_birdsoftheworld_horizontal_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: Macaulay Library (ml) -->
			<template v-if="product === 'ml'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForHeaderBreakpoint" style="--logoHeight: 1.75rem; --logoPadding: 1.25rem">
					<img :src="`${logoBaseUrl}clo_macaulaylibrary_short_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForHeaderBreakpoint" style="--logoHeight: 2.28rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_macaulaylibrary_horizontal_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: Merlin (merlin) -->
			<template v-if="product === 'merlin'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForMedium" style="--logoHeight: 2.25rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_merlin_short_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForMedium" style="--logoHeight: 6rem; --logoPadding: 1.5rem">
					<img :src="`${logoBaseUrl}clo_merlin_stacked_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: eBird (ebird) -->
			<template v-if="product === 'ebird'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForMedium" style="--logoHeight: 2.25rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_ebird_short_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForMedium" style="--logoHeight: 6rem; --logoPadding: 1.5rem">
					<img :src="`${logoBaseUrl}clo_ebird_stacked_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: eBird Minimal (ebird-min) -->
			<template v-if="product === 'ebird-min'">
				<a :href="homeUrl" class="HeaderIdentity-logo" style="--logoHeight: 2.25rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_ebird_short_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: eBird International treatment (ebird-intl) -->
			<template v-if="product === 'ebird-intl'">
				<a :href="homeUrl" class="HeaderIdentity-logo u-hideForMedium" style="--logoHeight: 2rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_ebird_solo_web.svg`" :alt="name" />
				</a>
				<a :href="homeUrl" class="HeaderIdentity-logo u-showForMedium" style="--logoHeight: 2.5rem; --logoPadding: 1.5rem">
					<img :src="`${logoBaseUrl}clo_ebird_solo_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: eBird International minimal treatment (ebird-intl-min) -->
			<template v-if="product === 'ebird-intl-min'">
				<a :href="homeUrl" class="HeaderIdentity-logo" style="--logoHeight: 2rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}clo_ebird_solo_web.svg`" :alt="name" />
				</a>
			</template>

			<!-- Product: eBird Portal (ebird-atlasXXX or ebird-gbbc) -->
			<template v-if="product.startsWith('ebird-atlas') || product === 'ebird-gbbc'">
				<a :href="homeUrl" class="HeaderIdentity-logo" style="--logoHeight: 2.5rem; --logoPadding: 1rem">
					<img :src="`${logoBaseUrl}portal/clo_ebird_${product.replace('ebird-', '')}_web.svg`" :alt="name" />
				</a>
			</template>
		</template>

		<!-- Custom heading with lab logo on top -->
		<template v-else-if="customHeading">
			<a :href="homeUrl" class="HeaderIdentity-custom" >
				<img class="u-hideForMedium" :src="`${logoBaseUrl}clo_sapsucker_web.svg`" alt="The Cornell Lab" style="--logoHeight: 1.5rem; --logoPadding: 1rem" />
				<img class="u-showForMedium" :src="`${logoBaseUrl}clo_primary_web.svg`" :alt="name" style="--logoHeight: 1.75rem" />
				<span class="HeaderIdentity-custom-heading">{{ customHeading }}</span>
			</a>
		</template>

		<!-- Custom slot -->
		<template v-else>
			<!-- @slot for the header identity logo-->
			<slot />
		</template>
	</div>
</template>

<script>
export default {
	name: 'CloHeaderIdentity',
	data() {
		return {};
	},
	props: {
		product: String,
		logoBaseUrl: {
			type: String,
			default: 'https://clo-brand-static-prod.s3.amazonaws.com/logos/clo',
		},
		homeUrl: {
			type: String,
			default: '/',
		},
		customHeading: String,
		name: {
			type: String,
			default: 'Cornell Lab',
		},
	},
	computed: {},
};
</script>

<style lang="scss">
.HeaderIdentity {
	display: inline-flex;
	align-items: center;
}

.HeaderIdentity-logo {
	display: inline-flex;
	padding: var(--logoPadding, 1.5rem);
	img {
		height: var(--logoHeight, 3rem);
	}
	@include breakpoint(medium) {
		flex-shrink: 0;
	}
}

.HeaderIdentity-custom {
	display: inline-flex;
	align-items: center;
	column-gap: $space-sm;
	row-gap: $space-sm;
	padding: var(--logoPadding, 1rem);
	img {
		height: var(--logoHeight, 2rem);
	}
	&-heading {
		letter-spacing: -0.02rem;
		@include text(4);
		font-weight: 300;
		@include interactiveColor(color, $color-text, $color-text);
		margin: 0;
	}
	@include breakpoint(medium) {
		flex-direction: column;
		align-items: flex-start;
		&-heading {
			@include text(6);
		}
	}
	.Header--minimal & {
		padding: var(--logoPadding, 1.25rem);
		img {
			height: var(--logoHeight, 1.75rem);
		}
		@include breakpoint(medium) {
			flex-direction: row;
			gap: $space-md;
			&-heading {
				@include text(5);
			}
		}
	}
}
</style>
